import { Component } from 'react';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { db } from '../services/firebase';
import { captureError } from '../services/monitoring';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
    captureError(error, { componentStack: info?.componentStack, type: 'react_crash' });
    const uid = getAuth().currentUser?.uid || null;
    if (uid) {
      addDoc(collection(db, 'crash_reports'), {
        type: 'js_crash',
        uid,
        message: error?.message || String(error),
        stack: error?.stack || null,
        componentStack: info?.componentStack || null,
        url: window.location.href,
        createdAt: serverTimestamp(),
      }).catch(() => {});
    }
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  handleBack = () => {
    this.setState({ hasError: false });
    window.history.back();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '60vh', padding: '24px',
          textAlign: 'center', fontFamily: 'inherit',
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '16px' }}>⚠️</div>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '8px', color: '#1f2937' }}>
            حدث خطأ غير متوقع
          </h2>
          <p style={{ color: '#6b7280', marginBottom: '24px', maxWidth: '360px' }}>
            نعتذر عن هذا الخطأ. يمكنك إعادة تحميل الصفحة أو العودة للصفحة السابقة.
          </p>
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={this.handleReload}
              style={{
                padding: '10px 24px', borderRadius: '8px', border: 'none',
                background: '#6366f1', color: '#fff', fontWeight: 600,
                cursor: 'pointer', fontSize: '0.95rem',
              }}
            >
              إعادة تحميل
            </button>
            <button
              onClick={this.handleBack}
              style={{
                padding: '10px 24px', borderRadius: '8px',
                border: '1px solid #d1d5db', background: '#fff',
                color: '#374151', fontWeight: 600, cursor: 'pointer',
                fontSize: '0.95rem',
              }}
            >
              العودة
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
